exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4be9f7ce] .el-dialog__body{height:100%}", ""]);

// exports
